// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Toastr } from "@revvsales/components";

// Actions Imports
import { deletePermaLinkAction } from "../../actions/DocumentActions";

class PermaDisablePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showButtunLoader: false,
    };
  }

  _toggleLoader = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _closePopup = () => {
    this.props.toggleModalPopUp("permaLinkOffPopup", false);
  };

  _submit = () => {
    this._toggleLoader("showButtunLoader", true);
    this.props
      .deletePermaLinkAction(this.props.docObjectId, "DOC")
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Magic link switched off and deleted",
          timeout: 3000,
        });
        this._toggleLoader("showButtunLoader", false);
        this.props.updateMultipleState({
          permaLinkOffPopup: false,
          showAcceptAndSignBtnLoader: false,
        });
      })
      .catch(error => {
        console.error(
          `QuotationTopBarV2 => _disablePermaLink => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
        this.props.updateMultipleState({
          permaLinkOffPopup: false,
          showAcceptAndSignBtnLoader: false,
        });
      });
  };

  render() {
    const { showButtunLoader } = this.state;
    return (
      <Modal open onClose={this._closePopup} center closeOnOverlayClick={false}>
        <div className="docrecipientspopup-container">
          {/* ----------- Modal Heading Section ----------- */}
          <div className="modal-heading" data-test="emptysigner-modal-heading">
            <FontAwesomeIcon
              className="emptysigner-popup-exclamation-icon"
              icon={["fas", "exclamation-triangle"]}
            />{" "}
            You are about to switch off magic link
          </div>

          <div className="permalink-popup-content-section">
            If you switch off magic link, the existing link will expire. Anyone
            you have shared the link with will not be able to access the
            document anymore.
          </div>

          <div className="permalink-popup-content-section">
            You can switch it on at anytime to get a new magic link for this
            document and reshare it with anyone.
          </div>

          {/* ----------- Modal Footer Section ----------- */}
          <div className="modal-footer">
            <Button
              className="btn-transparent"
              onClick={this._closePopup}
              data-test="permadisablepopup-cancel-btn">
              Cancel
            </Button>
            <Button
              id="emapty-signer-back-btn"
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="emptysigner-back-btn"
              isLoading={showButtunLoader}
              onClick={this._submit}>
              Switch off magic link
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  deletePermaLinkAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(PermaDisablePopup);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/PermaDisablePopup.js